import { GetCesionByFiltersDtoProps } from "./DTOs/GetCesionByFiltersDto"
import { GetCesionByIdDtoProps } from "./DTOs/GetCesionByIdDto"

export const cesionAdapter = (
  cesion: GetCesionByFiltersDtoProps
): GetCesionByFiltersDtoProps => {
  return {
    descripcion: cesion.descripcion,
    empresaInternaRazonSocial: cesion.empresaInternaRazonSocial,
    estado: cesion.estado,
    fechaInicioContrato: cesion.fechaInicioContrato,
    id: cesion.id,
    librador: cesion.librador,
  }
}

export const cesionByIdAdapter = (
  cesion: GetCesionByIdDtoProps
): GetCesionByIdDtoProps => ({
  id: cesion.id,
  cuentaInternaIban: cesion.cuentaInternaIban,
  descripcion: cesion.descripcion,
  empresaInternaNif: cesion.empresaInternaNif,
  empresaInternaRazonSocial: cesion.empresaInternaRazonSocial,
  estado: cesion.estado,
  fechaInicioContrato: cesion.fechaInicioContrato,
  observaciones: cesion.observaciones,
  tipo: cesion.tipo,
})
